module.exports = __webpack_public_path__ + "img/miyazaki.e6b0efdd.png";